<div class="p-3 pt-2 rounded-4">
  <div>
    <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0 d-flex justify-content-between">
      <div class="p-3">Rate Conversion</div>
      <button class="btn btn-info btn-sm bg-white me-3 mt-3 mb-3" (click)="addNew(content)">Add New</button>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row bg-white p-2 pt-0">
      <div class="col-md-12 mt-4 mb-5">
        <div class="table-responsive">
          <ag-grid-angular style="width: 100%; height: 600px" class="ag-theme-alpine"
            [columnDefs]="columnDefs" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)">
          </ag-grid-angular>
        </div>
      </div>
    </div>
  </div>
</div>


{{ setContent(content) }}

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ isEdit ? 'Edit' : 'New' }} Rate Conversion</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
  </div>
  <div class="modal-body">
    @if (addError) {
      <div class="alert alert-danger" role="alert">{{ addError }}</div>
    }
    <form #userForm="ngForm">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="required">From Country</label>
              <select class="form-control form-select" name="from" #fromCountry="ngModel" [disabled]="isEdit"
                [(ngModel)]="dataObj.from" required>
                @for (country of countries; track country) {
                  <option [value]="country._id">
                    {{ country.displayName }}
                  </option>
                }
              </select>
            </div>
            @if (fromCountry.touched && fromCountry.invalid) {
              <div class="text-danger">
                Please select From Country
              </div>
            }
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="required">To Country</label>
              <select class="form-control form-select" name="to" #toCountry="ngModel" [disabled]="isEdit"
                [(ngModel)]="dataObj.to" required>
                @for (country of countries; track country) {
                  <option [value]="country._id">
                    {{ country.displayName }}
                  </option>
                }
              </select>
            </div>
            @if (toCountry.touched && toCountry.invalid) {
              <div class="text-danger">
                Please select To Country
              </div>
            }
          </div>
          <div class="mt-3">
            <div class="col-md-6">
              <div class="form-group">
                <label class="required">Rate</label>
                <input type="number" step="any" #rate="ngModel" class="form-control" name="name"
                  [(ngModel)]="dataObj.rate" required min="0.000001">
              </div>
              @if (rate.touched && rate.invalid) {
                <div class="text-danger">
                  Please enter a valid positive rate
                </div>
              }
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mt-2 text-center">
            <button [disabled]="!userForm.valid" class="btn btn-primary active mt-4 w-50"
            (click)="onSubmit(userForm.valid)">Submit</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>